import { render, staticRenderFns } from "./PortalAbonadosComponent.vue?vue&type=template&id=8eafa88e"
import script from "./PortalAbonadosComponent.vue?vue&type=script&lang=js"
export * from "./PortalAbonadosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports